import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LoaderIcon = createValidIcon((props) => {
  const { size, color = 'surface-info-p-high-em' } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z'
        fill={color}
        fillOpacity='0.4'
      />

      <g>
        <animateTransform
          attributeName='transform'
          type='rotate'
          from='0 12 12'
          to='360 12 12'
          dur='800ms'
          repeatCount='indefinite'
        />

        <path
          d='M22.5 12C23.3284 12 24.0097 11.3259 23.9064 10.5039C23.7729 9.44209 23.4978 8.40064 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913445C15.5994 0.502197 14.5579 0.227052 13.4961 0.0936288C12.6741 -0.00965658 12 0.671573 12 1.5C12 2.32843 12.6761 2.98728 13.4931 3.12471C14.1609 3.23706 14.8155 3.4247 15.4442 3.68508C16.5361 4.13738 17.5282 4.80031 18.364 5.63604C19.1997 6.47177 19.8626 7.46392 20.3149 8.55585C20.5753 9.18447 20.7629 9.83908 20.8753 10.5069C21.0127 11.3239 21.6716 12 22.5 12Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
